import gql from "graphql-tag";

const GET_LOCATIONS_BY_DATE = gql`
  query getLocationsByDate(
    $groupCode: String!
    $latitude: Number!
    $longitude: Number!
    $distance: Integer!
  ) {
    locationsByDate(
      group_code: $groupCode
      latitude: $latitude
      longitude: $longitude
      distance: $distance
    )
      @rest(
        type: "getLocationsByDate"
        path: "/ggv/get_available_locations/{args.group_code}/{args.latitude}/{args.longitude}/{args.distance}"
        endpoint: "v1"
      ) {
      status
      results
    }
  }
`;

export { GET_LOCATIONS_BY_DATE as GGV_GET_LOCATIONS_BY_DATE };
